import api from './api';

const SEEN_KEY = 'tpp_seen_version';

export interface VersionInfo {
  version: string;
  release_notes_available: string[];
}

export async function getVersion(): Promise<VersionInfo> {
  const { data } = await api.get<VersionInfo>('/version/');
  return data;
}

export async function getReleaseNotesList(): Promise<string[]> {
  const { data } = await api.get<string[]>('/version/release-notes');
  return data;
}

export async function getReleaseNotes(version: string): Promise<string> {
  const { data } = await api.get<string>(`/version/release-notes/${version}`);
  return data;
}

export function hasUnseenVersion(currentVersion: string): boolean {
  const seen = localStorage.getItem(SEEN_KEY);
  return seen !== currentVersion;
}

export function markVersionSeen(version: string): void {
  localStorage.setItem(SEEN_KEY, version);
}
